"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class SignUp extends Parse.Object {
    constructor(attributes) {
        super('SignUp', attributes);
    }
    get retailerName() { return this.get('retailerName'); }
    set retailerName(value) { this.set('retailerName', value); }
    get streetNumber() { return this.get('streetNumber'); }
    set streetNumber(value) { this.set('streetNumber', value); }
    get street() { return this.get('street'); }
    set street(value) { this.set('street', value); }
    get suburb() { return this.get('suburb'); }
    set suburb(value) { this.set('suburb', value); }
    get state() { return this.get('state'); }
    set state(value) { this.set('state', value); }
    get city() { return this.get('city'); }
    set city(value) { this.set('city', value); }
    get zipCode() { return this.get('zipCode'); }
    set zipCode(value) { this.set('zipCode', value); }
    get ecommerceSite() { return this.get('ecommerceSite'); }
    set ecommerceSite(value) { this.set('ecommerceSite', value); }
    get ecommerceSiteOther() { return this.get('ecommerceSiteOther'); }
    set ecommerceSiteOther(value) { this.set('ecommerceSiteOther', value); }
    get businessSegment() { return this.get('businessSegment'); }
    set businessSegment(value) { this.set('businessSegment', value); }
    get businessSegmentOther() { return this.get('businessSegmentOther'); }
    set businessSegmentOther(value) { this.set('businessSegmentOther', value); }
    get companySize() { return this.get('companySize'); }
    set companySize(value) { this.set('companySize', value); }
    get name() { return this.get('name'); }
    set name(value) { this.set('name', value); }
    get lastName() { return this.get('lastName'); }
    set lastName(value) { this.set('lastName', value); }
    get email() { return this.get('email'); }
    set email(value) { this.set('email', value); }
    get phoneNumber() { return this.get('phoneNumber'); }
    set phoneNumber(value) { this.set('phoneNumber', value); }
    get phoneCountry() { return this.get('phoneCountry'); }
    set phoneCountry(value) { this.set('phoneCountry', value); }
    get phoneAreaCode() { return this.get('phoneAreaCode'); }
    set phoneAreaCode(value) { this.set('phoneAreaCode', value); }
    get apps() { return this.get('apps'); }
    set apps(value) { this.set('apps', value); }
    get ecommercePlatform() { return this.get('ecommercePlatform'); }
    set ecommercePlatform(value) { this.set('ecommercePlatform', value); }
    get ecommercePlatformOther() { return this.get('ecommercePlatformOther'); }
    set ecommercePlatformOther(value) { this.set('ecommercePlatformOther', value); }
}
exports.SignUp = SignUp;
Parse.Object.registerSubclass('SignUp', SignUp);
//# sourceMappingURL=SignUp.js.map